module.exports = __webpack_public_path__ + "static/media/producer.61f04e76.svg";